export const popup_props_transaltion = {
  lvl_1_code: 'Область',
  lvl_2_code: 'Район',
  name_ru: 'Название',
  title: 'Название',
  name: 'Название',
  mineraldeveloper: 'Разработчик полезных ископаемых',
  region: 'Район',
  vrp: 'ИФО ВВП, %',
  income: 'Среднедушевые номинальные доходы, тенге',
  inflation: 'Инфляция, %',
  rural_population: 'Сельское население',
  total_population: 'Численность населения, чел.',
  urban_population: 'Городское население',
  unemployment_rate: 'Уровень безработицы, %',
  description: 'Описание',
  iata_code: 'Код IATA',
  icao_code: 'Код ICAO',
  municipality: 'Территориальная единица',
  irr: 'IRR, %',
  ebitda: 'Доходность по EBITDA, %',
  gen_name: 'Категория',
  investment_sum: 'Сумма инвестиции, тыс. долл. США',
  payback_period: 'Срок окупаемости, лет',
  count_household: 'Количество домохозяйств, ед.',
  male_population: 'Мужское население',
  female_population: 'Женское население',
  people_per_household: 'Размер домохозяйства',
  rural_male_population: 'Сельское мужское население',
  urban_male_population: 'Городское мужское население',
  rural_female_population: 'Сельское женское население',
  urban_female_population: 'Городское женское население',
  deposit: 'Участок',
  collection: 'Стадия',
  nvp_sum: 'NPV, тыс. долл. США',
  vrp_mln_tg: 'ВРП, млн тенге',
  stats_text: 'Характеристика',
  short_desc_ru: 'Описание',
  search_rubric: 'Категория',
  address: 'Адрес',
  schedule: 'Режим работы',
  export_mln_usd: 'Экспорт, млн долл. США',
  import_mln_usd: 'Импорт, млн долл. США',
  total_mln_usd: 'Товарооборот, млн долл. США',
  international: 'Международного значения',
  oblast: 'Республиканского значения',
  republican: 'Областного значения',
};
